module.exports = __webpack_public_path__ + "img/air_pm25.c35621b2.svg";